/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOrgForMagicSettingsQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetOrgForMagicSettingsQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly allowMagic: boolean;
    readonly magicSettings: c.PartialOrgMagicSettings | null;
    readonly endorsedModeThreadsSetting: c.EndorsedModeThreadsSetting;
  };
};

export const GetOrgForMagicSettingsDocument = /*#__PURE__*/ gql`
  query GetOrgForMagicSettings($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      allowMagic
      magicSettings
      endorsedModeThreadsSetting
    }
  }
`;

/**
 * __useGetOrgForMagicSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrgForMagicSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgForMagicSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgForMagicSettingsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetOrgForMagicSettingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOrgForMagicSettingsQuery,
    GetOrgForMagicSettingsQueryVariables
  > &
    (
      | { variables: GetOrgForMagicSettingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOrgForMagicSettingsQuery,
    GetOrgForMagicSettingsQueryVariables
  >(GetOrgForMagicSettingsDocument, options);
}
export function useGetOrgForMagicSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOrgForMagicSettingsQuery,
    GetOrgForMagicSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOrgForMagicSettingsQuery,
    GetOrgForMagicSettingsQueryVariables
  >(GetOrgForMagicSettingsDocument, options);
}
export function useGetOrgForMagicSettingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOrgForMagicSettingsQuery,
    GetOrgForMagicSettingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOrgForMagicSettingsQuery,
    GetOrgForMagicSettingsQueryVariables
  >(GetOrgForMagicSettingsDocument, options);
}
export type GetOrgForMagicSettingsQueryHookResult = ReturnType<
  typeof useGetOrgForMagicSettingsQuery
>;
export type GetOrgForMagicSettingsLazyQueryHookResult = ReturnType<
  typeof useGetOrgForMagicSettingsLazyQuery
>;
export type GetOrgForMagicSettingsSuspenseQueryHookResult = ReturnType<
  typeof useGetOrgForMagicSettingsSuspenseQuery
>;
export type GetOrgForMagicSettingsQueryResult = Apollo.QueryResult<
  GetOrgForMagicSettingsQuery,
  GetOrgForMagicSettingsQueryVariables
>;
